import React from 'react'

import GlobalWrapper from 'components/global-wrapper'
import Hero from 'components/hero'
import Section from 'components/section'
import About from 'components/about'
import Work from 'components/work'
import Publications from '../components/Publications'
import Footer from 'components/footer'

const App = () => {
  return (
    <GlobalWrapper>
      {/* <Breakpoints /> */}
      <Hero />
      <Section id={'about'}>
        <About />
      </Section>
      <Section id={'projects'}>
        <Work />
      </Section>
      <Section>
        {/* <Publications /> */}
      </Section>
      <Footer />
    </GlobalWrapper>
  )
}

export default App
